import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ToastService } from '../../../../core/toast/toast.service';
import { TOAST_COLORS, TOAST_ICONS } from './toast.model';

@Component({
  selector: 'om-toast',
  templateUrl: './toast.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('toastAnim', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(100%) scale(0.95)' }),
        animate('280ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateX(0) scale(1)' })),
      ]),
      transition(':leave', [
        animate('200ms cubic-bezier(0.55, 0, 1, 0.45)', style({ opacity: 0, transform: 'translateX(100%) scale(0.95)' })),
      ]),
    ]),
  ],
})
export class Toast {
  protected readonly toastService = inject(ToastService);
  protected readonly icons = TOAST_ICONS;
  protected readonly colors = TOAST_COLORS;
}
